import React from 'react';

const NotFound = () => {
    return (
        <div style={{
            width: "100%", height: "100vh", display: "flex", justifyContent: "center",
            alignItems: "center", flexDirection: "column"
        }}>
            <h1>This link is no longer valid</h1>

        </div>
    );
};

export default NotFound;
